import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";

const statusLabelMap = {
  CRA: "Credit Review Analis",
  "APPV-1": "APPROVAL 1",
  "APPV-2": "APPROVAL 2",
  "APPV-3": "FINAL APPROVE",
};

const columns = [
  // {
  //   title: "Tanggal",
  //   dataIndex: "tgl",
  //   key: "tgl",
  //   render: (text) => <p>{formatTanggal(text)}</p>,
  // },
  {
    title: "Application ID",
    dataIndex: "application_id",
    key: "application_id",
    // width: 200,
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NAMA",
    dataIndex: "nama",
    key: "nama",
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NIK",
    dataIndex: "nik",
    key: "nik",
  },
  // {
  //   title: "MARITAL STATUS",
  //   dataIndex: "statuspernikahan",
  //   key: "statuspernikahan",
  //   // render: (text) => (
  //   //   <a
  //   //     href={text}
  //   //     // href="https://www.google.com"
  //   //     target="_blank"
  //   //     rel="noreferrer"
  //   //     style={{ color: "blue", textDecoration: "underline" }}
  //   //   >
  //   //     Menikah
  //   //   </a>
  //   // ),
  // },
  // {
  //   title: "NOMOR HP",
  //   dataIndex: "nohp",
  //   key: "nohp",
  //   render: (text) => <a>{text || "-"}</a>,
  // },
  // {
  //   title: "STATUS",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (text) => {
  //     const cleaned = text?.replace(/\s+/g, ""); // hilangkan spasi jika ada

  //     const statusLabelMap = {
  //       CRA: "Credit Review Analis",
  //       "APPV-1": "APPROVAL 1",
  //       "APPV-2": "APPROVAL 2",
  //       "APPV-3": "APPROVAL 3",
  //       FA: "FINAL APPROVE",
  //       Rejected: "REJECTED",
  //     };

  //     const statusColorMap = {
  //       CRA: "#ff4d4f", // Merah terang (butuh perhatian)
  //       "APPV-1": "rgba(255, 102, 0, 1)", // Kuning (review/pertimbangan)
  //       "APPV-2": "#ffff00", // Hijau muda (positif, lanjut)
  //       "APPV-3": "#00ff00", // Hijau tua (final, disetujui)
  //       FA: "#0000ff",
  //     };

  //     const label = statusLabelMap[cleaned] || text;
  //     const bgColor = statusColorMap[cleaned] || "#d9d9d9";
  //     // const textColor = cleaned === 'APPV-3' ? '#fff' : '#000' || 'APPV-2' ? '#fff' : '#000'; // biar hijau tua tetap kebaca
  //     // const textColor = cleaned === 'APPV-2' ? '#000' : '#fff' || cleaned === 'APPV-3' ? '#000' : '#fff';

  //     const darkTextStatuses = ["APPV-2", "APPV-3"];
  //     const textColor = darkTextStatuses.includes(cleaned) ? "#000" : "#fff";

  //     return (
  //       <span
  //         style={{
  //           backgroundColor: bgColor,
  //           color: textColor,
  //           padding: "4px 10px",
  //           borderRadius: "4px",
  //           fontWeight: "bold",
  //           fontSize: "12px", // ukuran font lebih kecil
  //           display: "inline-block", // penting agar width bekerja
  //           width: "150px", // sesuaikan lebar sesuai kebutuhan
  //           textAlign: "center", // agar teks di tengah
  //         }}
  //       >
  //         {label}
  //       </span>
  //     );
  //   },
  // },

  // {
  //   title: "STATUS",
  //   dataIndex: "is_survey",
  //   key: "is_survey",
  //   render: (text) => (
  //     <p className="capitalize font-semibold">
  //       {text == 1 ? "Survey In Progress" : "Rejected"}
  //     </p>
  //   ),
  // },
];

const formValidation = [
  [
    {
      title: "No. Akun",
      key: "noAcc",
      placeholder: "Masukan No. Akun",
      type: "text",
      required: true,
      validationText: "nomor akun harus diisi!",
    },
    {
      title: "Nama Akun",
      key: "nameAcc",
      placeholder: "Masukan Nama Akun",
      type: "text",
      required: true,
      validationText: "nama akun harus diisi!",
    },
  ],
  {
    title: "Tanggal Masuk",
    key: "tgl",
    placeholder: "Masukan tanggal masuk Anggota",
    type: "dateTime",
    required: true,
    validationText: "tanggal masuk harus diisi!",
  },
  {
    title: "Keterangan",
    key: "keterangan",
    placeholder: "Masukan Keterangan",
    type: "textarea",
    required: true,
    validationText: "alamat harus diisi!",
  },
  [
    {
      title: "Debet",
      key: "debet",
      placeholder: "Masukan Debet",
      type: "number",
      required: true,
      validationText: "Debet harus diisi!",
    },
    {
      title: "Kredit",
      key: "kredit",
      placeholder: "Masukan Kredit",
      type: "number",
      required: true,
      validationText: "Kredit harus diisi!",
    },
    {
      title: "Saldo",
      key: "saldo",
      placeholder: "Masukan Saldo",
      type: "number",
      required: true,
      validationText: "Saldo harus diisi!",
    },
  ],
];

export { columns };
